var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "header" } },
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { cols: "12", id: "main_content_maxwidthset" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0",
              attrs: { align: "center", id: "header_body" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0",
                  staticStyle: { "font-weight": "bold", "font-size": "1rem" },
                  attrs: { cols: "auto" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        this.$i18n.locale == "jp"
                          ? _vm.formatDateLang(_vm.today, "jp")
                          : this.$i18n.locale == "en"
                          ? _vm.formatDateLang(_vm.today, "en")
                          : _vm.formatDateLang(_vm.today, "ko")
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }